import axios from 'axios'

export default function (context, val) {
    let form = context.state.form;
    if (!val && !val.value) {
        context.commit('set_form', {
            ContragentID: '',
            ContragentName: null,
            PartnerLegalEntityId: (form.ContragentType !== 1 && form.ContragentType !== 5) ? null : 0,
        });
    } else {

        context.commit('set_form', {
            ContragentID: val.value,
            ContragentName: val.label,
            PartnerLegalEntityId: null,
        });
        context.state.options.legals = [];
        if (form.ContragentType !== 1 && form.ContragentType !== 5) {
            axios({
                method: 'POST',
                url: '/tourclient/masterAgent/dictionary/partnerLegal/list',
                data: {request: JSON.stringify({PartnerId: val.value})},
            }).then(r => {
                let main;
                r.data.Items.forEach(i => {
                    if (i.IsMain) main = i.Id;
                    context.state.options.legals.push({
                        contragent: i.PartnerID,
                        value: i.Id,
                        label: i.Name || i.NameFull,
                    });
                });
                context.commit('set_form', {
                    PartnerLegalEntityId: main ? main : (r.data.Items[0] ? r.data.Items[0].Id : null),
                });
            });
        }
    }
}